import React, { Component } from 'react'
import './MoveCounter.scss';



const MoveCounter = () => {


  const formatNumber = (num: any) => {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  };

  const rawMoveCount: any = localStorage.getItem("MoveCount");
  const moveCount: any = formatNumber(rawMoveCount);

  return (


    <aside className="movecounter">


      {rawMoveCount ?
        (<>
          <p className="movecounter-text">
            In the last 12 months
      <br />
            we've moved
      <span id="movecounter-number">
              {moveCount}
            </span>
            homes near you!
      </p>

          <p className="movecounter-slogan">
            We're pretty good at it.
      </p>
        </>) :

        ( //This is the fallback message in case the data doesn't come through for some reason.
          <>
            <p className="movecounter-text">
              In the last 27 years,
          <br />
              we've completed
            <span id="movecounter-number">
                over <br /> 1 million moves!
            </span>

            </p>

            <p className="movecounter-slogan">
              We're pretty good at it.
            </p>
          </>
        )



      }


      <div className="movewithus-background-container">
        <div className="movewithus-inner-container">
          <svg
            viewBox="0 0 300 130"
            preserveAspectRatio="xMidYMid meet"
            width="100%"
          >
            <path id="curve" d="M 0 80 Q 150 130 300 80" fill="none" />
            <text x="150" y="50" className="movewithus">
              Move with us
          </text>
            <text className="confidently" x="150" y="30" width="300">
              <textPath href="#curve">
                Confidently
            </textPath>
            </text>
          </svg>
        </div>
      </div>

    </aside>

  )

}

export default MoveCounter;
